export const StatusBadge = ({ status }) => {
  const styles = {
    pending: "bg-[#C5A059]/15 text-[#8a6d33] border-[#C5A059]/40",
    confirmed: "bg-[#0A3F2F]/10 text-[#0A3F2F] border-[#0A3F2F]/30",
    completed: "bg-emerald-600/10 text-emerald-700 border-emerald-600/30",
    cancelled: "bg-gray-200 text-gray-500 border-gray-300",
  };
  return (
    <span data-testid={`status-badge-${status}`}
      className={`text-[11px] font-semibold px-2.5 py-1 rounded-full border capitalize whitespace-nowrap ${styles[status] || styles.pending}`}>
      {status}
    </span>
  );
};

export const inputCls = "w-full border border-[#E5E7E5] rounded-md px-3 py-2.5 text-sm focus:ring-2 focus:ring-[#0A3F2F]/50 focus:outline-none bg-white";

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex items-start justify-between gap-4">
    <div>
      <h1 className="text-2xl font-bold text-[#1C1C1C]">{title}</h1>
      <p className="text-[#5C6A63] text-sm mt-1">{subtitle}</p>
    </div>
    {action}
  </div>
);
